import kevinAvatar from "@/assets/images/kevin.jpg";
import shenAvatar from "@/assets/images/shen.jpg";
import michaelAvatar from "@/assets/images/michael.jpg";
import harryAvatar from "@/assets/images/harry.jpg";
const ACCOUNT_ID_PREFIX = "acct_";
// Temporary stopgap: team avatars are hardcoded by email until we wire stable profile/account metadata.
const TEAM_AVATAR_BY_EMAIL = {
    "kevin@kchang.me": kevinAvatar,
    "notshenita@icloud.com": shenAvatar,
    "m@mckain.com": michaelAvatar,
    "harry.sanabria@gmail.com": harryAvatar,
};
const TEAM_AVATAR_BY_INITIAL = {
    K: kevinAvatar,
    S: shenAvatar,
    M: michaelAvatar,
    H: harryAvatar,
};
function resolvePlaceholderInitial(accountId) {
    const trimmed = accountId.trim();
    if (!trimmed)
        return "?";
    const normalized = trimmed.startsWith(ACCOUNT_ID_PREFIX)
        ? trimmed.slice(ACCOUNT_ID_PREFIX.length)
        : trimmed;
    const firstAlphanumeric = normalized.match(/[a-zA-Z0-9]/)?.[0];
    if (!firstAlphanumeric)
        return "?";
    return firstAlphanumeric.toUpperCase();
}
function resolveDisplayInitial(displayValue) {
    if (!displayValue)
        return undefined;
    const firstAlphanumeric = displayValue.trim().match(/[a-zA-Z0-9]/)?.[0];
    if (!firstAlphanumeric)
        return undefined;
    return firstAlphanumeric.toUpperCase();
}
function normalizeLookupKey(value) {
    if (!value)
        return undefined;
    const normalized = value.trim().toLowerCase();
    return normalized.length > 0 ? normalized : undefined;
}
function resolveAvatarFromInitial(initial) {
    if (!initial)
        return undefined;
    return TEAM_AVATAR_BY_INITIAL[initial];
}
export function resolveAttributionIdentity(createdByAccountId, members) {
    const matchingMember = members?.find((member) => member.accountId === createdByAccountId);
    const emailKey = normalizeLookupKey(matchingMember?.email);
    if (emailKey) {
        const emailAvatar = TEAM_AVATAR_BY_EMAIL[emailKey];
        if (emailAvatar) {
            return {
                avatarSrc: emailAvatar,
                initial: resolveDisplayInitial(matchingMember?.email) ?? resolvePlaceholderInitial(createdByAccountId),
            };
        }
    }
    const placeholderInitial = resolvePlaceholderInitial(createdByAccountId);
    const initialAvatar = resolveAvatarFromInitial(placeholderInitial);
    if (initialAvatar) {
        return {
            avatarSrc: initialAvatar,
            initial: placeholderInitial,
        };
    }
    const emailInitial = resolveDisplayInitial(matchingMember?.email);
    if (emailInitial) {
        const emailInitialAvatar = resolveAvatarFromInitial(emailInitial);
        if (emailInitialAvatar) {
            return {
                avatarSrc: emailInitialAvatar,
                initial: emailInitial,
            };
        }
        return { initial: emailInitial };
    }
    const usernameInitial = resolveDisplayInitial(matchingMember?.username);
    if (usernameInitial) {
        const usernameInitialAvatar = resolveAvatarFromInitial(usernameInitial);
        if (usernameInitialAvatar) {
            return {
                avatarSrc: usernameInitialAvatar,
                initial: usernameInitial,
            };
        }
        return { initial: usernameInitial };
    }
    return { initial: placeholderInitial };
}
